import { render, staticRenderFns } from "./Middag.vue?vue&type=template&id=82617534&"
import script from "./Middag.vue?vue&type=script&lang=js&"
export * from "./Middag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports